import React from "react"

const Video = ( {videoURL, placeholder, autoPlay} ) => {
  let muted = false
  
  if(videoURL){
    if(videoURL === '1'){
      videoURL = 'https://kaarmibeing.s3.eu-west-2.amazonaws.com/media/free-trial-6-enemies.mp4'
    } else if(videoURL === '2'){
      videoURL = 'https://kaarmibeing.s3.eu-west-2.amazonaws.com/media/free-trial-personalities.mp4'
    } else if(videoURL === '3'){
      videoURL = 'https://kaarmibeing.s3.eu-west-2.amazonaws.com/media/free-trial-4-layers.mp4'
    } else if(videoURL === 'team'){
      videoURL = 'https://kaarmibeing.s3.eu-west-2.amazonaws.com/media/kaarmibeing-team-video.mp4'
    } else {
      videoURL = 'https://kaarmibeing.s3.eu-west-2.amazonaws.com/media/free-trial-6-enemies.mp4'
    }
  }

  return (
    <div
      className="video"
      style={{
        position: "relative",
        paddingBottom: "56.25%" /* 16:9 */,
        paddingTop: 25,
        height: 0
      }}
    >
      <video 
        controls 
        disablePictureInPicture 
        autoPlay={autoPlay}
        muted={muted}
        controlsList="nodownload"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%"
        }}
        poster={placeholder}
      >
            <source src={videoURL} type="video/mp4" />
      </video>
    </div>
  )
}
export default Video
